export interface IResponseGetPlans {
  broker: {
    month: IFrecuencyPlan[]
    trimester: IFrecuencyPlan[]
    semester: IFrecuencyPlan[]
    year: IFrecuencyPlan[]
  }
}
export type TFrequencyLower = 'month' | 'trimester' | 'semester' | 'year'

export type TFrequency = 'MONTH' | 'TRIMESTER' | 'SEMESTER' | 'YEAR'

export type TPlanId = 'STARTER' | 'ADVANCED'

export interface UnitPriceDiscount {
  total: number
  unitPrice: string
  onlyNexts?: boolean
}

export interface PercentDiscount {
  total: number
  percentDiscount: number
}

export interface RangeUnits {
  type: 'range_units'
  discounts: UnitPriceDiscount[]
}

export interface RangePercent {
  type: 'range_percent'
  discounts: PercentDiscount[]
}

export type DiscountData = RangeUnits | RangePercent

export interface IFrecuencyPlan {
  planId: TPlanId
  frequency: TFrequency
  value: string
  label: string
  price: string
  discount: null | string
  discountPercentSquema: DiscountData
  userSlots: number
  userSlotsWithPromotion: number
  developmentSlots: null
  conekta: {
    interval: string
    frecuency: number
  }
  payment: IPaymentPlans
}

export interface IPaymentPlans {
  made: boolean
  allowed: boolean
  methods: IMethodsPayment
}

export interface IMethodsPayment {
  cards: boolean
  oxxo: boolean
}

export interface IResponseGetAddOns {
  i24: IPortalAddOns[]
  m3: IPortalAddOns[]
}

export interface IPortalAddOns {
  type: string
  typeDescription: string
  payment: IPaymentAddOns
  credits: ICreditInPortal[]
  value: string
}

export interface ICreditInPortal {
  type: string
  typePretty: string
  credits: number
  portal: Portal
}

export enum Portal {
  I24 = 'I24',
  M3 = 'M3'
}

export interface IPaymentAddOns {
  allowedByFrequencies: any[]
  price: string
}

export interface IPaymentAddOns {
  allowedByFrequencies: any[]
  price: string
}

export interface IPaymentValue {
  total: string
  expiresAt: string
  type?: string
  isActiveRenovation?: boolean
}

export interface IPlanItem {
  planId: string
  frequency: TFrequency
  addonDescription?: string
  addonPortal?: string
  totalBrokers: number
  totalBrokersAssigned?: number
  isAddon?: boolean
  payment?: IPaymentValue
}

export interface IPlan {
  id: string
  items: IPlanItem[]
  trial?: boolean
}

export interface ICustomPlanResponse {
  status: 'ACTIVE' | 'PENDING'
  plan: IPlan
  payment?: IPaymentValue
}

export interface IAddOnResponse {
  description: string
  id: string
  name: string
  provider: 'I24' | 'ML'
  prices: {
    frequency: 'MONTH'
    unitPrice: number
  }[]
}

export interface IAddOn {
  description: string
  id: string
  name: string
  prices: {
    frequency: 'MONTH'
    unitPrice: number
  }[]
}

export interface IAddOns {
  i24: IAddOn[]
  m3: IAddOn[]
}

export interface IUnitPrices {
  price: number
  quantity: number
}
export interface IPlanV2 {
  description: string
  id: string
  name: string
  prices: {
    frequency: 'MONTH'
    unitPrices: IUnitPrices[]
  }[]
}

export interface IResponseGetShopData {
  plans: IPlanV2[]
  addOns: IAddOnResponse[]
}

export interface IProduct {
  id: string
  quantity: number
  frequency: TFrequency
}
